export const GENERIC_EXPORT_SETUP_GET_EXPORTFILETYPE =
  'GENERIC_EXPORT_SETUP_GET_EXPORTFILETYPE';
export const GENERIC_EXPORT_SETUP_GET_EXPORTFILEFIELD =
  'GENERIC_EXPORT_SETUP_GET_EXPORTFILEFIELD';
export const GENERIC_EXPORT_SETUP_SET_LOADING =
  'GENERIC_EXPORT_SETUP_SET_LOADING';
export const GENERIC_EXPORT_SETUP_SET_SUBMITTING =
  'GENERIC_EXPORT_SETUP_SET_SUBMITTING';
export const GENERIC_EXPORT_SETUP_ERROR = 'GENERIC_EXPORT_SETUP_ERROR';
export const GENERIC_EXPORT_SETUP_CLEAR_ERROR =
  'GENERIC_EXPORT_SETUP_CLEAR_ERROR';
export const GENERIC_EXPORT_SETUP_SET_SUCCESSFUL =
  'GENERIC_EXPORT_SETUP_SET_SUCCESSFUL';
export const GENERIC_EXPORT_SETUP_SET_EXPORTFILETYPE =
  'GENERIC_EXPORT_SETUP_SET_EXPORTFILETYPE';
export const GENERIC_EXPORT_SETUP_SET_EXPORTFILETYPEFUTURE =
  'GENERIC_EXPORT_SETUP_SET_EXPORTFILETYPEFUTURE';



// WEBPACK FOOTER //
// ./src/pages/genericexportsetup/state/setup/types.js